import { useQuery } from '@tanstack/react-query';

import type { TTalentUser } from '@/shared/contexts/talent-auth/hooks/use-get-user-data';

import { fetcher } from '../utils/fetcher';

const ENDPOINT = process.env.MODERN_TALENT_API_INTEGRATION;

/* generates the x-talent-authorization token header */
export const useXTalentAuthorizationToken = ({
  user,
}: { user: TTalentUser | null }) => {
  const { data, isError, error, isPending } = useQuery({
    queryKey: ['learning-jwt', user?.employee_id],
    queryFn: () =>
      fetcher<{ token: string }>(
        `${ENDPOINT}/learningintegration/security/generate-token`,
        {
          method: 'POST',
          body: String(user?.employee_id),
          skipAuth: true,
        },
      ),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(user),
  });

  if (isError) {
    console.error('Generate Talent Token error', error);
  }

  const token = typeof data === 'object' ? data.token : undefined;

  return {
    token,
    isPending,
  };
};
